module.exports = __webpack_public_path__ + "img/tiny-plus.61c5fb4a.png";